import React from 'react'

import Section from '../Section'
import LabeledInput from '../StaticLabelInput'

import addressIcon from 'assets/images/contacts/Editor/editor-address-20.svg'

import { useTranslation } from 'react-i18next'

interface AddressesProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const Addresses = ({
  editData,
  onFieldChange,
  onLabelChange,
  onAddItem,
  onDelete,
}: AddressesProps) => {
  const { t } = useTranslation()
  return (
    <Section
      editData={editData}
      propName="addresses"
      labelList={[
        { key: 'work', label: t('contact.property.work') },
        { key: 'home', label: t('contact.property.home') },
        { key: 'other', label: t('contact.property.other') },
        { key: '', label: t('contact.property.none') },
        { key: 'custom', label: t('contact.property.custom') },
      ]}
      icon={addressIcon}
      addButtonLabel={t('contact.menu.addAddress')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(_) => true}
      inputFieldsRender={(index: number) => {
        const data = editData.addresses[index]

        return (
          <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <LabeledInput
              id={'street'}
              label={t('contact.property.street')}
              value={data.street}
              onChange={(value) => onFieldChange('addresses/street', index, value)}
            />
            <div style={{ display: 'flex', gap: '10px' }}>
              <LabeledInput
                id={'city'}
                label={t('contact.property.city')}
                value={data.city}
                onChange={(value) => onFieldChange('addresses/city', index, value)}
              />
              <LabeledInput
                id={'state'}
                label={t('contact.property.state')}
                value={data.state}
                onChange={(value) => onFieldChange('addresses/state', index, value)}
              />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <LabeledInput
                id={'postalCode'}
                label={t('contact.property.postalCode')}
                value={data.postalCode}
                onChange={(value) => onFieldChange('addresses/postalCode', index, value)}
              />
              <LabeledInput
                id={'country'}
                label={t('contact.property.country')}
                value={data.country}
                onChange={(value) => onFieldChange('addresses/country', index, value)}
              />
              <LabeledInput
                id={'po_box'}
                label={t('contact.property.poBox')}
                value={data.po_box}
                onChange={(value) => onFieldChange('addresses/po_box', index, value)}
              />
            </div>
          </div>
        )
      }}
    />
  )
}
export default Addresses
